import AccountCommunication from './AccountCommunication';

class AuctanePayCommunication extends AccountCommunication {
	static init(params) {
		AccountCommunication.init(params);
	}

	static getAPSession(data) {
		data.returnUrl = window.location.href;
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/payment/auctanepay/`,
			data,
		});
	}

	static getAPConfig(data) {
		return this.axiosRequest({
			url: `${this.accountApiUrlPrefix}/payment/auctanepay/config/?custid=${data.customerId}`,
		});
	}

	static deletePaymentMethods(paymentId) {
		return this.axiosRequest({
			method: 'delete',
			url: `${this.accountApiUrlPrefix}/payment/auctanepay/${paymentId}`,
		});
	}
}

export default AuctanePayCommunication;
